/**
 * @module stores/criteria
 * @description 검색 조건 영속화 Pinia 스토어 — 접수 관리 및 접수 이력 페이지의
 * 날짜 범위, 검색 유형, 상태 필터 등 검색 조건을 저장하여 탭 전환 후에도 유지합니다.
 */
import { defineStore } from 'pinia'
import { startOfMonth } from 'date-fns'

export const useCriteriaStore = defineStore('criteria', {
  state: () => {
    return {
      RepairRequestManagement: {
        fromDate: new Date(),
        toDate: new Date(),
        type: '', // 기본값 설정
        text: '',
        requestStatus: '', // 기본값 설정
        areaMainCode: '',
        areaSubCode: '',
        customerName: '',
        customerPhoneNumber: '', // 어시스턴트 '더보기' 필터 전달 + 탭 전환 시 전화 조건 유지
        serialNumber: ''
      },
      RepairRequestHistory: {
        fromDate: new Date(),
        toDate: new Date(),
        type: '', // 기본값 설정
        text: '',
        requestStatus: '', // 기본값 설정
        areaMainCode: '',
        areaSubCode: ''
      },
      // SURINP-218: 리포트 공통 필터 — BE 스펙(SURINP-215) 정렬
      // "제품군"은 도메인의 ProductModel 매핑 → productModelId
      Report: {
        fromDate: startOfMonth(new Date()), // SURINP-837: 처음 열면 이번 달 1일 ~ 오늘
        toDate: new Date(),
        customerId: '',
        productModelId: ''
      }
    }
  },
  getters: {
    /** @returns {object} 접수 현황 관리 검색 조건 */
    getSearchManagementCriteria: (state) => state.RepairRequestManagement,
    /** @returns {object} 접수 이력 검색 조건 */
    getSearchHistoryCriteria: (state) => state.RepairRequestHistory,
    /** @returns {object} 리포트 공통 검색 조건 */
    getReportCriteria: (state) => state.Report
  },
  actions: {
    /**
     * 지정한 모듈의 검색 조건을 업데이트합니다.
     *
     * @param {'RepairRequestManagement'|'RepairRequestHistory'|'Report'} type - 업데이트할 모듈 키
     * @param {object} data - 설정할 검색 조건 데이터
     */
    setSearchCriteria(type, data) {
      if (type === 'RepairRequestManagement') {
        this.RepairRequestManagement = data
      } else if (type === 'RepairRequestHistory') {
        this.RepairRequestHistory = data
      } else if (type === 'Report') {
        this.Report = data
      }
    }
  }
})
